export { default as default } from './ChangePasswordModal';
